import { render, staticRenderFns } from "./FadeAwayMessage.vue?vue&type=template&id=528a592f&scoped=true"
import script from "./FadeAwayMessage.vue?vue&type=script&lang=js"
export * from "./FadeAwayMessage.vue?vue&type=script&lang=js"
import style0 from "./FadeAwayMessage.vue?vue&type=style&index=0&id=528a592f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a592f",
  null
  
)

export default component.exports